import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import AppContainer from './src/app.container'
import setupInterceptors from './src/interceptor'
import configureStore from './src/store'
import { BrowserRoutesProvider, OIDC, handleLoggedIn, logoutHandler } from './src/helpers/OktaUtility';
import { BannerProvider } from './src/providers/banner'
import './src/assets/themes/main.scss'
import '@astmpkg/common-functions/dist/index.css';
import { BrowserRouter as Router } from 'react-router-dom'

(() => {
	let isJiraEnabled = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_ENABLED
	if (isJiraEnabled === 'true') {
		let src = process.env.REACT_APP_JIRA_ISSUE_COLLECTOR_URL
		// eslint-disable-next-line no-useless-escape
		document.write('<script src="' + src + '"><\/script>')
	}
})()

// TODO : set up required props.
const OKTA_PROPS = {
	OIDC,
	handleLoggedIn,
	logoutHandler
}
// Configure Store
const store = configureStore({}, {})
// Configure Interceptor
setupInterceptors(store)
// Configure Provider
createRoot(document.getElementById('root')).render(
	<Provider store={store}>
		<Router basename='/'>
		    <BrowserRoutesProvider OIDC_CONFIG={OIDC}>
			    <BannerProvider>
				    <AppContainer {...OKTA_PROPS} />
			    </BannerProvider>
		    </BrowserRoutesProvider>
		</Router>
	</Provider>
);
